import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { useAccessContext } from '../AccessProvider'
import ContributorContainer from '../Components/ContributorContainer'
import UserContributor from '../Components/UserContributor'
import UserDropdown from '../Components/UserDropdown'
import useContributorActions from '../hooks/useContributorActions'
import { AccessAccount } from '../types'
import { CONTRIBUTOR_RIGHTS } from '../utils'

export interface IProjectPublicTab {
  resourceOwner: AccessAccount
  onOwnerChange?: (newOwner: AccessAccount) => void
}

const ProjectPublicTab = ({
  resourceOwner,
  onOwnerChange,
}: IProjectPublicTab) => {
  const { t } = useUIComponentsContext()
  const { userContributors, users } = useAccessContext()

  const { handleAddUser, handleAddTeam, ...rest } = useContributorActions(
    'User',
    resourceOwner
  )

  const contributorRights = CONTRIBUTOR_RIGHTS(t)

  return (
    <>
      {resourceOwner && (
        <ContributorContainer
          title={t?.('access.owner')}
          containerClassName="bg-oxford-gray-50"
          contributors={
            <UserContributor
              account={resourceOwner}
              access={contributorRights.OWNER.value}
              onOwnerChange={onOwnerChange}
            />
          }
        />
      )}

      <div className="py-3">
        <div className="text-oxford-gray-400 uppercase mb-2 text-xs">
          {t?.('access.editors')}
        </div>
        {!!userContributors?.length && (
          <div className="pb-3 flex flex-col gap-3">
            {userContributors.map(({ account, access, ...restUser }) => (
              <UserContributor
                key={account.id}
                account={account}
                access={access}
                disableAccessDropdown
                {...restUser}
                {...rest}
              />
            ))}
          </div>
        )}
        <UserDropdown
          placeholder={t?.('buttons.addUserWithEditPermission')}
          onChange={(user) =>
            handleAddUser(user as AccessAccount, contributorRights.EDITOR.value)
          }
        />
      </div>
    </>
  )
}

export default ProjectPublicTab
